import React from 'react';
import { ArrowRight } from 'lucide-react';

const QuickAccessCard = ({ icon: Icon, title, description, onClick, href, color = 'primary' }) => {
  const colorClasses = {
    primary: 'bg-primary-lighter/30 text-primary hover:bg-primary-lighter/50',
    blue: 'bg-info/10 text-info hover:bg-info/20',
    green: 'bg-success/10 text-success hover:bg-success/20',
    orange: 'bg-warning/10 text-warning hover:bg-warning/20',
    red: 'bg-error/10 text-error hover:bg-error/20',
  };

  const iconBgClasses = {
    primary: 'bg-primary/10',
    blue: 'bg-info/20',
    green: 'bg-success/20',
    orange: 'bg-warning/20',
    red: 'bg-error/20',
  };

  const Component = href ? 'a' : 'button';
  const props = href
    ? { href, target: '_blank', rel: 'noopener noreferrer' }
    : { onClick };

  return (
    <Component
      {...props}
      className={`group flex items-center gap-4 p-4 rounded-xl transition-all duration-200 ${colorClasses[color]} cursor-pointer`}
    >
      <div className={`w-12 h-12 rounded-lg ${iconBgClasses[color]} flex items-center justify-center flex-shrink-0`}>
        <Icon size={24} />
      </div>
      <div className="flex-1 text-left min-w-0">
        <h4 className="font-medium text-text-primary group-hover:text-current transition-colors truncate">
          {title}
        </h4>
        {description && (
          <p className="text-sm text-text-tertiary truncate">{description}</p>
        )}
      </div>
      <ArrowRight
        size={18}
        className="text-text-tertiary group-hover:text-current group-hover:translate-x-1 transition-all flex-shrink-0"
      />
    </Component>
  );
};

export default QuickAccessCard;


